import { PollQuestionNumberProps } from './types';

export const PollQuestionNumber = ({ pollQuestionNumber }: PollQuestionNumberProps) => (
    <div className="size-10 rounded-l-lg rounded-br-lg bg-white font-medium inline-flex items-center justify-center">{pollQuestionNumber}</div>
);
